import { Component, OnInit } from '@angular/core';
import { SsrService } from 'src/app/services/ssr/ssr.service';

@Component({
  selector: 'app-ranjit',
  templateUrl: './ranjit.component.html',
  styleUrls: ['./ranjit.component.scss']
})
export class RanjitComponent implements OnInit {
  result:{name:string ,title:string, link:string} [] = [];
  constructor(private ssrService : SsrService) { }

  ngOnInit(): void {
    this.result = this.ssrService.getRanjit();
  }

}
